<template>
  <div class="py-2 mb-3" v-if="pack">
    <v-row no-gutters>
      <v-col sm="12">
        <div>
          <div class="title d-inline-block pb-3" style="margin-top: -10px;" data-cy="progressBar__progress">
            Progress: {{ statusLabel(pack) }}
          </div>
          <div class="d-inline-block ml-2">
            <v-rating></v-rating>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row justify="space-between" no-gutters>
      <v-col sm="3">
        <i class="fas fa-caret-down"></i>
        {{ uatStartFormatted }}
      </v-col>
      <v-col sm="3">
        <i class="fas fa-caret-down"></i>
        {{ uatQ1 }}
      </v-col>
      <v-col sm="3">
        <i class="fas fa-caret-down"></i>
        {{ uatQ2 }}
      </v-col>
      <v-col sm="3">
        <v-row cols="12" no-gutters>
          <v-col sm="6">
            <i class="fas fa-caret-down"></i>
            {{ uatQ3 }}
          </v-col>
          <v-col sm="6" class="text-sm-right">
            {{ uatEndFormatted }}
            <i class="fas fa-caret-down"></i>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12">
        <div style="border: 1px solid #3772c9; border-radius: 7px; padding: 3px;">
          <div
            class="och-progress-bar"
            :style="
              `background-color: ${statusColor(pack)}; width: ${percentageTestPlan(pack)}%; color: ${statusText(pack)};`
            "
            data-cy="progressBar__releasesComplete"
          >
            {{ percentageTestPlan(pack) }}% Releases Complete ({{ pack.completion.complete }}/{{
              pack.completion.total
            }})
          </div>
          <div
            class="mt-1 och-progress-bar och-progress-bar--uat"
            :style="`width: ${percentageTime(pack)}%;`"
            data-cy="progressBar__todayPosition"
          >
            {{ percentageTime(pack) }}% UAT Timeline Elapsed
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import "twix";

import { mapActions, mapState } from "vuex";

import uatUtil from "@/lib/uatUtil";

const progressColors = {
  "On Track": {
    background: "#32a025",
    text: "white",
  },
  Watch: {
    background: "#a331bb",
    text: "white",
  },
  Behind: {
    background: "#ffd026",
    text: "black",
  },
  Critical: {
    background: "#de2200",
    text: "white",
  },
};

export default {
  computed: {
    pack() {
      const packIdRouteParam = this.packIdRouteParam;

      return this.packList.find(pack => pack.id === packIdRouteParam);
    },
    packIdRouteParam() {
      return parseInt(this.$route.params.packId, 10);
    },
    uatEndFormatted() {
      return moment.utc(this.pack.uatEnd).format("MMM D");
    },
    uatQ1() {
      return moment(this.uatStart)
        .add(this.uatQuartileLength, "days")
        .format("MMM D");
    },
    uatQ2() {
      return moment(this.uatStart)
        .add(this.uatQuartileLength * 2, "days")
        .format("MMM D");
    },
    uatQ3() {
      return moment(this.uatStart)
        .add(this.uatQuartileLength * 3, "days")
        .format("MMM D");
    },
    uatQuartileLength() {
      const diff = this.uatStart.twix(this.pack.uatEnd);
      const diffCount = diff.count("days");
      const quartileLength = (diffCount - (diffCount % 4)) / 4;

      return quartileLength;
    },
    uatStart() {
      return moment.utc(this.pack.uatStart);
    },
    uatStartFormatted() {
      return this.uatStart.format("MMM D");
    },
    ...mapState({
      packList: state => state.pack.packList,
    }),
  },
  async created() {
    await this.getPackList();
  },
  methods: {
    percentageTestPlan(pack) {
      return uatUtil.getPercentCompleteTestPlans(pack);
    },
    percentageTime(pack) {
      return uatUtil.getPercentCompleteTime(pack);
    },
    status(pack) {
      return uatUtil.getStatus(pack);
    },
    statusLabel(pack) {
      return uatUtil.getStatusLabel(pack);
    },
    statusColor(pack) {
      const status = this.statusLabel(pack);

      return progressColors[status].background;
    },
    statusText(pack) {
      const status = this.statusLabel(pack);

      return progressColors[status].text;
    },
    ...mapActions({
      getPackList: "pack/getList",
    }),
  },
  name: "progressBar",
};
</script>

<style scoped>
.och-segment--active {
  border-bottom: 5px solid #3772c9;
}
.och-segment--inactive {
  border-bottom: 5px solid transparent;
}
.och-progress-bar {
  min-width: 200px;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
}
.och-progress-bar--uat {
  background-color: #3772c9;
  color: white;
}
</style>
